var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeadsList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 97995"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7065",
    width: 16,
    height: 16,
    fill: "#EDF3FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_164_19837",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 3H5.5V13H2.5V3ZM6.5 3H9.5V10H6.5V3ZM13.5 3H10.5V13H13.5V3Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3H6.5V2H5.5V3ZM2.5 3V2H1.5V3H2.5ZM5.5 13V14H6.5V13H5.5ZM2.5 13H1.5V14H2.5V13ZM9.5 3H10.5V2H9.5V3ZM6.5 3V2H5.5V3H6.5ZM9.5 10V11H10.5V10H9.5ZM6.5 10H5.5V11H6.5V10ZM10.5 3V2H9.5V3H10.5ZM13.5 3H14.5V2H13.5V3ZM10.5 13H9.5V14H10.5V13ZM13.5 13V14H14.5V13H13.5ZM5.5 2H2.5V4H5.5V2ZM6.5 13V3H4.5V13H6.5ZM2.5 14H5.5V12H2.5V14ZM1.5 3V13H3.5V3H1.5ZM9.5 2H6.5V4H9.5V2ZM10.5 10V3H8.5V10H10.5ZM6.5 11H9.5V9H6.5V11ZM5.5 3V10H7.5V3H5.5ZM10.5 4H13.5V2H10.5V4ZM11.5 13V3H9.5V13H11.5ZM13.5 12H10.5V14H13.5V12ZM12.5 3V13H14.5V3H12.5Z",
    fill: "#2068F3",
    mask: "url(#path-2-inside-1_164_19837)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsList);
export default __webpack_public_path__ + "static/media/leads-list.0eb73316e5ab104b40f4b7e65b01149a.svg";
export { ForwardRef as ReactComponent };